module.exports = __webpack_public_path__ + "static/media/LiveCall.cc1cb8ba.svg";